import { HttpError } from './HttpError.js';
export class ApiError extends HttpError {
    constructor(request, response, data) {
        super(request, response);
        this.data = data;
    }
}
//# sourceMappingURL=ApiError.js.map